import { Pipe, PipeTransform } from '@angular/core';
export class TNKCurrencyPipe implements PipeTransform {
/**
 * @param {?} str
 * @param {?} type
 * @return {?}
 */
transform(str: string, type: string) {
    if (!str) return false;

    if (!type) return false;

    let /** @type {?} */ tmp = parseInt(str).toString();

    switch (type) {
      case 'rupiah': {
        tmp = tmp.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        tmp = `Rp ${tmp}`;

        break;
      }

      case 'usd': {
        tmp = tmp.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        tmp = `USD ${tmp}`;

        break;
      }
    }

    return tmp;
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'tnkCurrency',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TNKCurrencyPipe_tsickle_Closure_declarations() {
/** @type {?} */
TNKCurrencyPipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TNKCurrencyPipe.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
